/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function NetworkHelpCenter() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Deploying Content to Players </h2>
        <h3 className="helpHeaderSubTitle">CAMPAIGN OR CALENDAR</h3>
        <div className="helpContentSection">
          {" "}
          <div className="mb-3">
            <div className="boldTitle">Find the Screens </div>
            <div>
              In the Network tab, search for the screen (or group of screens)
              that you would like. Screens can be sorted by a variety of factors
              (form factors, time zone, etc) by clicking on the “three lines”
              button in the top right and searching.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/networkCenterImg4.png")}
          />
          <div>
            <div className="imageRow mb-3">
              <div className="imageSection">
                {" "}
                <img
                  alt=""
                  src={require("../../assets/images/helpCenter/networkCenterImg5.png")}
                />
              </div>
              <div className="imageInfoSection">
                <div className="boldTitle">
                  Select to Play on Individual Screens
                </div>
                <div>
                  Click the box to the left of the screen name that you’re
                  deploying to, and then push the “Play” button.
                </div>
              </div>
            </div>
            <div className="imageRow mb-3">
              <div className="imageSection">
                {" "}
                <img
                  alt=""
                  src={require("../../assets/images/helpCenter/networkCenterImg6.png")}
                />
              </div>
              <div className="imageInfoSection">
                <div className="boldTitle">
                  Select to Play on Group of Screens
                </div>
                <div>
                  Select all or click each box to the left of the screen name
                  that you’re deploying to, and then push the “Play” button in
                  the top right.
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Choose What's Playing</div>
            <div>
              Select the Campaign or Calendar you would like to push to the
              selected screen(s) by clicking the dropdown and searching for the
              campaign or calendar by name. By default Campaign will come up,
              click on “Calendar” to the right and use that drop down menu to
              switch this.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/networkCenterImg7.png")}
          />
        </div>
      </div>
      <div className="mb-3">
        <div className="boldTitle mt-2">Publishing Content</div>
        <div>
          Confirm that all the host screens are the same form factor as the
          campaign or calendar you are sending to, then click “Send Campaign.”
        </div>{" "}
      </div>

      <img
        alt=""
        src={require("../../assets/images/helpCenter/networkCenterImg1.png")}
      />
      <ul>
        <li className="questionRow nestedListItem mb-3">
          <p className="questionSection">1.</p>{" "}
          <p className="answerSection">
            Wait until a confirmation message pops up on the bottom of the
            screen to confirm it was sent successfully - this could take
            anywhere from two seconds to a minute depending on file size.
          </p>
        </li>
        <img
          alt=""
          src={require("../../assets/images/helpCenter/networkCenterImg2.png")}
        />
      </ul>
      <div className="mb-3">
        <div className="boldTitle mt-2">Stopping Content</div>
        <div>
          Calendars automatically stop when their time is up but campaigns need
          to be manually stopped. To do so select the screens and press the
          “Stop” button in the top right.
        </div>
      </div>
      <img
        alt=""
        src={require("../../assets/images/helpCenter/networkCenterImg3.png")}
      />
    </div>
  );
}
